var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightReverseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 23,
    viewBox: "0 0 12 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24907 22.1875C1.09279 22.1884 0.937866 22.1584 0.793184 22.0993C0.648502 22.0402 0.516908 21.9532 0.405948 21.8431C0.294645 21.7327 0.206303 21.6014 0.146015 21.4567C0.0857269 21.312 0.0546875 21.1567 0.0546875 21C0.0546875 20.8432 0.0857269 20.688 0.146015 20.5433C0.206303 20.3986 0.294645 20.2672 0.405948 20.1569L9.0747 11.5L0.405948 2.8431C0.182337 2.61949 0.0567147 2.31621 0.0567147 1.99998C0.0567147 1.84339 0.0875552 1.68834 0.147477 1.54368C0.207398 1.39902 0.295227 1.26757 0.405948 1.15685C0.516669 1.04613 0.648113 0.958302 0.792777 0.89838C0.93744 0.838459 1.09249 0.807617 1.24907 0.807617C1.56531 0.807617 1.86859 0.93324 2.0922 1.15685L11.5922 10.6569C11.7035 10.7672 11.7918 10.8986 11.8521 11.0433C11.9124 11.188 11.9435 11.3432 11.9435 11.5C11.9435 11.6567 11.9124 11.812 11.8521 11.9567C11.7918 12.1014 11.7035 12.2327 11.5922 12.3431L2.0922 21.8431C1.98124 21.9532 1.84964 22.0402 1.70496 22.0993C1.56028 22.1584 1.40536 22.1884 1.24907 22.1875Z",
    fill: "#776B16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightReverseIcon);
export default __webpack_public_path__ + "static/media/right-reverse-icon.bd15ad51a3425cbb09f02c140976fa04.svg";
export { ForwardRef as ReactComponent };